import * as React from 'react';
import { LazyImage } from './lazyImage/LazyImage';
import { getCalculatedThumbnail } from './image.utils';
import { EagerImage } from './eagerImage/EagerImage';
import { OptionalAdditionalStyle } from '../../components.utils';
import { ImageWrapper } from './ImageWrapper';
import { Thumbnail } from './image.types';

export interface ImageDataProps {
  lazyLoad?: boolean,
  dataId?:string
}
type ImageProps = ImageDataProps & OptionalAdditionalStyle & Thumbnail;

export const Image: React.FunctionComponent<ImageProps> = props => {
  const { description, host, path, aspectRatio = { x: 16, y: 9 }, additionalStyle, lazyLoad, dataId, baseStyleConfiguration } = props;
  const CalculatedImage = lazyLoad ? LazyImage : EagerImage;
  return (
    <ImageWrapper aspectRatio={aspectRatio} additionalStyle={additionalStyle} dataId={dataId} baseStyleConfiguration={baseStyleConfiguration}>
      <CalculatedImage {...getCalculatedThumbnail(aspectRatio, description, host, path)} />
    </ImageWrapper>
  );
};
